import { render, staticRenderFns } from "./survey3.vue?vue&type=template&id=2c2d0a2d&scoped=true&"
import script from "./survey3.vue?vue&type=script&lang=js&"
export * from "./survey3.vue?vue&type=script&lang=js&"
import style0 from "./survey3.vue?vue&type=style&index=0&id=2c2d0a2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2d0a2d",
  null
  
)

export default component.exports